import * as yup from 'yup';


export const addDiscountsValidationSchema = (productPrice = 0, existingDiscountValues) => {
  return yup.object().shape({
    values: yup
      .array()
      .min(1, 'Custom option should have at least one value')
      .required('Field is required')
      .of(
        yup.object({
          price: yup
            .number()
            .nullable().typeError('Allowed numbers only')
            .when(
              'price_type',
              {
                is: (val) => val === 'percent',
                then: yup
                  .number()
                  .typeError('Field is required')
                  .max(100, 'Max percentage discount 100%')
                  .test(
                    'price',
                    'Discount already exist',
                    (val, options) => {
                      const values = existingDiscountValues?.filter(
                        (o) => o.price_type === 'percent'
                      ) || [];
                      const valueOrder =  options?.from?.[0]?.value?.sort_order || 0;
                      const discountsValuesToAdd = options?.from?.[1]?.value?.values?.filter(
                        (o) => o.sort_order !== valueOrder && o.price_type === 'percent'
                      ) || [];

                      if (!discountsValuesToAdd && !existingDiscountValues) {
                        return true;
                      }

                      const prices = [
                        ...values,
                        ...discountsValuesToAdd
                      ].map((v) => v.price);

                      return !prices.includes(val);
                    }
                  )
                  .required('Field is required')
              }
            )
            .when(
              'price_type',
              {
                is: (val) => val === 'fixed',
                then: yup
                  .number()
                  .typeError('Field is required')
                  .min(0, 'Discount must be greater or equal 0')
                  .max(productPrice, `Discount can't be greater $${productPrice.toFixed(2)}`)
                  .test(
                    'price',
                    'Discount already exist',
                    (val, options) => {
                      const values = existingDiscountValues?.filter(
                        (o) => o.price_type === 'fixed'
                      ) || [];
                      const valueOrder =  options?.from?.[0]?.value?.sort_order || 0;
                      const discountsValuesToAdd = options?.from?.[1]?.value?.values?.filter(
                        (o) => o.sort_order !== valueOrder && o.price_type === 'fixed'
                      ) || [];

                      if (!discountsValuesToAdd && !existingDiscountValues) {
                        return true;
                      }

                      const prices = [
                        ...values,
                        ...discountsValuesToAdd
                      ].map((v) => v.price);

                      return !prices.includes(val);
                    }
                  )
                  .required('Field is required')
              }
            ),
          price_type: yup
            .string()
            .required('Field is required')
        })
      )
  });
};
